import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Routes, RouterModule } from "@angular/router";
import { SectorsAndIndustriesPageComponent } from "./sectors-and-industries-page/sectors-and-industries-page.component";

import { SectorsAndIndustriesSummaryComponent } from "./sectors-and-industries-summary/sectors-and-industries-summary.component";
import { SectorDetailsComponent } from "./sector-details/sector-details.component";
import { SharedModule } from "../shared/shared.module";
import { NzSkeletonModule } from "ng-zorro-antd/skeleton";
import { NzDividerModule } from "ng-zorro-antd/divider";

const sectorsAndIndustriesRoutes: Routes = [
  {
    path: "",
    component: SectorsAndIndustriesPageComponent,
    data: {
      title: "Sectors & Industries Page",
    },
  },
  {
    path: "**",
    redirectTo: "/home",
  },
];
@NgModule({
  imports: [RouterModule.forChild(sectorsAndIndustriesRoutes)],
  exports: [RouterModule],
  declarations: [],
})
export class SectorsAndIndustriesPageRoutingModule {}
@NgModule({
  declarations: [
    SectorsAndIndustriesPageComponent,
    SectorsAndIndustriesSummaryComponent,
    SectorDetailsComponent,
  ],
  imports: [
    CommonModule,
    SectorsAndIndustriesPageRoutingModule,

    SharedModule,
    NzSkeletonModule,
    NzDividerModule,
  ],
})
export class SectorsAndIndustriesPageModule {}
